
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { EntityType, NotificationState, NotificationState__get_AsString } from "../../Shared/AssignmentNotification.js";
import { toLocalTime, toString, now, compare } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ConfirmationDialog, Dialog } from "../../Components/Dialog.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { Msg } from "./Types.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState_get_empty, FormState__getValidation } from "../../Shared/Shared.js";
import { InformationAlert, ErrorAlert } from "../../Components/Alert.js";
import { isEmpty, exists as exists_1, empty as empty_1, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Button, TextButton } from "../../Components/Button.js";
import { SignatureDialog } from "../../Components/SignatureDialog.js";
import { TextValue } from "../../Components/Text.js";
import { usePermissions } from "../../UserPermissions.js";
import { Permission, Permissions_has } from "../../Shared/Roles.js";
import { exists } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { PropertyList } from "../../Widgets/PropertyListWidget.js";
import { TableContainer } from "../../Widgets/Container.js";
import { ConsumableTable, SetTable, ToolWithQuantityTable, entityImageColumns, ToolTable } from "../../Widgets/Notification/AssignmentEntityTables.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import Check from "../../../public/assets/icons/Check.svg";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

function stateKey(notificationState) {
    return concat("assignment_notification.state.", ...NotificationState__get_AsString(notificationState));
}

function isPaused(detail) {
    const matchValue = detail.PausedUntil;
    if (matchValue == null) {
        return false;
    }
    else {
        return compare(matchValue, now()) > 0;
    }
}

function PauseDialog(props) {
    let Title, elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = (props.IsPaused ? t("assignment_notification.unpause_title") : t("assignment_notification.pause_title")), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5", "max-w-xl"])], (elems = toList(delay(() => append(singleton(reactElement("p", {
            children: props.IsPaused ? t("assignment_notification.unpause_description") : t("assignment_notification.pause_description"),
        })), delay(() => append(!props.IsPaused ? singleton(createElement(DatePicker, {
            ComponentState: componentState,
            IsClearable: false,
            Label: t("assignment_notification.paused_until"),
            MinDate: now(),
            OnChange: (date) => {
                props.Dispatch(new Msg(15, [date]));
            },
            TestId: "pause-assignment-notification-date-test-id",
            Value: unwrap(props.PausedUntilDate),
        })) : empty(), delay(() => {
            const matchValue = FormState__getValidation(props.FormState, t, "global");
            if (matchValue == null) {
                return empty();
            }
            else {
                return singleton(createElement(ErrorAlert, {
                    Label: matchValue,
                }));
            }
        })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: () => {
                props.Dispatch(new Msg(14, [false]));
            },
            TestId: "close-pause-assignment-notification-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: (!props.IsPaused && (props.PausedUntilDate == null)) ? "disabled" : componentState,
            Label: t("general.save"),
            OnClick: () => {
                if (props.IsPaused) {
                    props.Dispatch(new Msg(17, []));
                }
                else {
                    props.Dispatch(new Msg(16, []));
                }
            },
            TestId: "save-pause-assignment-notification-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: () => {
            props.Dispatch(new Msg(14, [false]));
        },
        Title: Title,
    }));
}

function SignatureSection(props) {
    let elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsSignatureDialogOpen = patternInput_1[1];
    return reactElement("div", createObj(singleton_1((elems_2 = toList(delay(() => append(singleton(createElement(SignatureDialog, {
        Classes: empty_1(),
        Description: "",
        FormState: FormState_get_empty(),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsSignatureDialogOpen(false);
        },
        OnConfirm: (file) => {
            props.Dispatch(new Msg(6, [file]));
            setIsSignatureDialogOpen(false);
        },
    })), delay(() => {
        let elems_1, elems;
        const matchValue = props.Signature;
        if (matchValue == null) {
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "normal",
                TestId: "",
                Text: t("notification.signature_description"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => singleton(createElement(TextButton, {
                ComponentState: props.ComponentState,
                Label: t("notification.sign"),
                OnClick: () => {
                    setIsSignatureDialogOpen(true);
                },
                TestId: "assignment-notification-sign-button-test-id",
                Variant: "blueButton",
            }))));
        }
        else {
            const signature = matchValue;
            const imageUrl = URL.createObjectURL(signature);
            return singleton(reactElement("div", createObj(singleton_1((elems = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("general.signature"),
            }), reactElement("img", {
                className: join(" ", ["h-24"]),
                src: imageUrl,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])))));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

function DetailContent(props) {
    let elems_5;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const isOpenNotification = equals(props.Detail.CurrentState, new NotificationState(0, []));
    const isReceiver = equals(props.Detail.ReceiverId, props.UserData.UserId);
    const isSender = props.Detail.SenderId === props.UserData.UserId;
    const canPause = Permissions_has(permissions, new Permission(111, [])) && ((props.Detail.ReceiverId == null) ? true : isSender);
    const notificationIsPaused = isPaused(props.Detail);
    const canUploadReceiverImages = isReceiver && isOpenNotification;
    const receiverActionState = exists((_arg, files) => exists_1((file) => {
        if (file.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, files), props.State.SelectedReceiverFilesByEntity) ? "disabled" : componentState;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems_5 = toList(delay(() => {
        let Title;
        return append(singleton(createElement(ConfirmationDialog, (Title = t("notification.reject"), {
            Description: t("assignment_notification.reject_confirmation"),
            FormState: props.FormState,
            IsOpen: props.State.IsRejectDialogOpen,
            OnClose: () => {
                props.Dispatch(new Msg(10, [false]));
            },
            OnConfirm: () => {
                props.Dispatch(new Msg(11, []));
            },
            Title: Title,
        }))), delay(() => {
            let Title_1;
            return append(singleton(createElement(ConfirmationDialog, (Title_1 = t("assignment_notification.withdraw"), {
                Description: t("assignment_notification.withdraw_confirmation"),
                FormState: props.FormState,
                IsOpen: props.State.IsWithdrawDialogOpen,
                OnClose: () => {
                    props.Dispatch(new Msg(12, [false]));
                },
                OnConfirm: () => {
                    props.Dispatch(new Msg(13, []));
                },
                Title: Title_1,
            }))), delay(() => append(singleton(createElement(PauseDialog, {
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                IsOpen: props.State.IsPauseDialogOpen,
                IsPaused: notificationIsPaused,
                PausedUntilDate: unwrap(props.State.PausedUntilDate),
            })), delay(() => {
                let elems, Title_2;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "px-12", "py-9"])], (elems = [createElement(PropertyList, (Title_2 = t("assignment_notification.title"), {
                    Properties: toList(delay(() => append(singleton({
                        Label: t("general.sender"),
                        TestId: "assignment-notification-sender-name-test-id",
                        Value: props.MailDetail.SenderName,
                    }), delay(() => append(singleton({
                        Label: t("general.receiver"),
                        TestId: "assignment-notification-receiver-name-test-id",
                        Value: props.MailDetail.ReceiverName,
                    }), delay(() => append(singleton({
                        Label: t("assignment_notification.state"),
                        TestId: "assignment-notification-state-test-id",
                        Value: t(stateKey(props.Detail.CurrentState)),
                    }), delay(() => {
                        let matchValue, returnDate;
                        return append((matchValue = props.MailDetail.OptionalReturnDate, (matchValue == null) ? (empty()) : ((returnDate = matchValue, singleton({
                            Label: t("tool.planned_return_date"),
                            TestId: "assignment-notification-planned-return-date-test-id",
                            Value: toString(toLocalTime(returnDate), "dd.MM.yyyy"),
                        })))), delay(() => append((props.MailDetail.Comment !== "") ? singleton({
                            Label: t("general.comment"),
                            TestId: "assignment-notification-comment-test-id",
                            Value: props.MailDetail.Comment,
                        }) : empty(), delay(() => {
                            let pausedUntil;
                            const matchValue_1 = props.Detail.PausedUntil;
                            let matchResult, pausedUntil_1;
                            if (matchValue_1 != null) {
                                if ((pausedUntil = matchValue_1, notificationIsPaused)) {
                                    matchResult = 0;
                                    pausedUntil_1 = matchValue_1;
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0:
                                    return singleton({
                                        Label: t("assignment_notification.paused_until"),
                                        TestId: "assignment-notification-paused-until-test-id",
                                        Value: toString(toLocalTime(pausedUntil_1), "dd.MM.yyyy"),
                                    });
                                default: {
                                    return empty();
                                }
                            }
                        }))));
                    })))))))),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                    let Title_3;
                    return append(!isEmpty(props.MailDetail.Tools) ? singleton(createElement(TableContainer, (Title_3 = t("general.tool"), {
                        Content: createElement(ToolTable, {
                            ExtraColumns: entityImageColumns((row) => row.Id, new EntityType(0, []), props.Detail.Images, props.State.SelectedReceiverFilesByEntity, canUploadReceiverImages, componentState, t, (tupledArg) => {
                                props.Dispatch(new Msg(2, [tupledArg[0], tupledArg[1], tupledArg[2]]));
                            }),
                            Tools: props.MailDetail.Tools,
                        }),
                        Title: unwrap(Title_3),
                    }))) : empty(), delay(() => {
                        let Title_4;
                        return append(!isEmpty(props.MailDetail.ToolsWithQuantity) ? singleton(createElement(TableContainer, (Title_4 = t("general.tool_with_quantity"), {
                            Content: createElement(ToolWithQuantityTable, {
                                ExtraColumns: entityImageColumns((row_1) => row_1.Id, new EntityType(1, []), props.Detail.Images, props.State.SelectedReceiverFilesByEntity, canUploadReceiverImages, componentState, t, (tupledArg_1) => {
                                    props.Dispatch(new Msg(2, [tupledArg_1[0], tupledArg_1[1], tupledArg_1[2]]));
                                }),
                                ToolsWithQuantity: props.MailDetail.ToolsWithQuantity,
                            }),
                            Title: unwrap(Title_4),
                        }))) : empty(), delay(() => {
                            let Title_5;
                            return append(!isEmpty(props.MailDetail.Sets) ? singleton(createElement(TableContainer, (Title_5 = t("general.set"), {
                                Content: createElement(SetTable, {
                                    ExtraColumns: entityImageColumns((row_2) => row_2.Id, new EntityType(2, []), props.Detail.Images, props.State.SelectedReceiverFilesByEntity, canUploadReceiverImages, componentState, t, (tupledArg_2) => {
                                        props.Dispatch(new Msg(2, [tupledArg_2[0], tupledArg_2[1], tupledArg_2[2]]));
                                    }),
                                    Sets: props.MailDetail.Sets,
                                }),
                                Title: unwrap(Title_5),
                            }))) : empty(), delay(() => {
                                let Title_6;
                                return append(!isEmpty(props.MailDetail.Consumables) ? singleton(createElement(TableContainer, (Title_6 = t("general.consumable"), {
                                    Content: createElement(ConsumableTable, {
                                        Consumables: props.MailDetail.Consumables,
                                        ExtraColumns: entityImageColumns((row_3) => row_3.Id, new EntityType(3, []), props.Detail.Images, props.State.SelectedReceiverFilesByEntity, canUploadReceiverImages, componentState, t, (tupledArg_3) => {
                                            props.Dispatch(new Msg(2, [tupledArg_3[0], tupledArg_3[1], tupledArg_3[2]]));
                                        }),
                                    }),
                                    Title: unwrap(Title_6),
                                }))) : empty(), delay(() => {
                                    let elems_3, elems_1, elems_2, elems_4;
                                    return isOpenNotification ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "sm:flex-row", "gap-3", "justify-between", "bg-white", "rounded", "px-5", "sm:px-12", "py-9"])], (elems_3 = [reactElement("div", createObj(singleton_1((elems_1 = toList(delay(() => append((isReceiver && props.MailDetail.WithSignature) ? singleton(createElement(SignatureSection, {
                                        ComponentState: componentState,
                                        Dispatch: props.Dispatch,
                                        Signature: unwrap(props.Signature),
                                    })) : empty(), delay(() => {
                                        const matchValue_2 = FormState__getValidation(props.FormState, t, "global");
                                        if (matchValue_2 == null) {
                                            return empty();
                                        }
                                        else {
                                            return singleton(createElement(ErrorAlert, {
                                                Label: matchValue_2,
                                            }));
                                        }
                                    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2", "sm:gap-5", "place-items-center"])], (elems_2 = toList(delay(() => append(canPause ? singleton(createElement(TextButton, {
                                        ComponentState: componentState,
                                        Label: notificationIsPaused ? t("assignment_notification.unpause") : t("assignment_notification.pause"),
                                        OnClick: () => {
                                            props.Dispatch(new Msg(14, [true]));
                                        },
                                        TestId: "assignment-notification-pause-button-test-id",
                                        Variant: "blueButton",
                                    })) : empty(), delay(() => {
                                        let Label_7;
                                        return append(isSender ? singleton(createElement(Button, (Label_7 = t("assignment_notification.withdraw"), {
                                            ComponentState: componentState,
                                            Icon: Delete_1(),
                                            Label: Label_7,
                                            OnClick: () => {
                                                props.Dispatch(new Msg(12, [true]));
                                            },
                                            TestId: "assignment-notification-withdraw-button-test-id",
                                            Variant: "redButton",
                                        }))) : empty(), delay(() => {
                                            let Label_8;
                                            return isReceiver ? append(singleton(createElement(Button, (Label_8 = t("notification.reject"), {
                                                ComponentState: receiverActionState,
                                                Icon: Delete_1(),
                                                Label: Label_8,
                                                OnClick: () => {
                                                    props.Dispatch(new Msg(10, [true]));
                                                },
                                                TestId: "assignment-notification-reject-button-test-id",
                                                Variant: "redButton",
                                            }))), delay(() => {
                                                let Label_9;
                                                return singleton(createElement(Button, (Label_9 = t("notification.accept"), {
                                                    ComponentState: (props.MailDetail.WithSignature && (props.Signature == null)) ? "disabled" : receiverActionState,
                                                    Icon: Check(),
                                                    Label: Label_9,
                                                    OnClick: () => {
                                                        if (props.MailDetail.WithSignature && (props.Signature != null)) {
                                                            props.Dispatch(new Msg(7, []));
                                                        }
                                                        else {
                                                            props.Dispatch(new Msg(9, []));
                                                        }
                                                    },
                                                    TestId: "assignment-notification-accept-button-test-id",
                                                    Variant: "primary",
                                                })));
                                            })) : empty();
                                        }));
                                    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "px-12", "py-9"])], (elems_4 = [createElement(InformationAlert, {
                                        Label: t("assignment_notification.not_open"),
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                                }));
                            }));
                        }));
                    }));
                }));
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function AssignmentNotificationDetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.NotificationId, props.UserData), update_1, (_arg_1, _arg_1_1) => {
    }), undefined, [props.NotificationId]);
    const state_1 = patternInput[0];
    const matchValue = state_1.Detail;
    const matchValue_1 = state_1.MailDetail;
    let matchResult, detail, mailDetail;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            detail = matchValue.fields[0];
            mailDetail = matchValue_1.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(DetailContent, {
                Detail: detail,
                Dispatch: patternInput[1],
                FormState: state_1.FormState,
                MailDetail: mailDetail,
                Signature: unwrap(state_1.Signature),
                State: state_1,
                UserData: props.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

